module.exports = __webpack_public_path__ + "media/images/bg-sand-f44c10382456040bbe8228713b518602.jpg";